import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { MineralInventory } from '@shared/models/records/mineral-inventory.model';
import { environment } from '@environments/environment';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';

@Component({
  selector: 'app-mineral-inventory-result-card',
  templateUrl: './mineral-inventory-result-card.component.html',
  styleUrls: ['./mineral-inventory-result-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class MineralInventoryResultCardComponent extends BaseComponent implements OnInit, OnDestroy {

    @Input() record: any;
    @Input() searchTerm: string;
    searchTerms: string;
    isSingleClick: Boolean = true;     

    constructor(
        private injector: Injector,
        private route: ActivatedRoute,
        private el: ElementRef,
        private r2: Renderer2) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.record = new MineralInventory(this.record._source);
        this.searchTerms = this.searchTerm;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    ngAfterViewInit(): void {
        AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
    }

    get mdi_ident() {
        return this.record.mdi_ident;
    }

    get name() {
        return this.record.deposit_name;
    }

    get status() {
        return this.record.deposit_status;
    }

    get primaryCommodities(): any[] {
        return this.record.primary_commodities;
    }

    get secondaryCommodities(): any[] {
        return this.record.secondary_commodities;
    }

    get townships(): any[] {
        return this.record.townships;
    }

    get recordNames() {
        return this.record.all_names;
    }

    openInSameTab() {
        this.isSingleClick = true;
        setTimeout(()=>{
            if(this.isSingleClick){
                this.router.navigate(['/mineral-inventory', this.mdi_ident], { state: { data: this.record, searchTerms: this.searchTerms} });
            }
        }, 250)
    }

    openInNewTab() {
        this.isSingleClick = false;
        var target = environment.application_url + "persistent-linking?" + DatabaseIndexNameType.mineralInventory + "=" + this.mdi_ident;
        this.router.navigate([], { state: { data: this.record, searchTerms: this.searchTerms} }).then(() => {  window.open(target, '_blank'); });
    }
}